"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiatePaypalResponseMapper = void 0;
var InitiatePaypalResponseMapper = /** @class */ (function () {
    function InitiatePaypalResponseMapper(data) {
        this.localData = data;
    }
    InitiatePaypalResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return InitiatePaypalResponseMapper;
}());
exports.InitiatePaypalResponseMapper = InitiatePaypalResponseMapper;
//# sourceMappingURL=InitiatePaypalResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/InitiatePaypalResponseMapper.js
// module id = 2209
// module chunks = 8